/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Decline_Reason_RequiredInputs */

const en_task_decline_reason_required = /** @type {(inputs: Task_Decline_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason before completing this activity.`)
};

const pt_br2_task_decline_reason_required = /** @type {(inputs: Task_Decline_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um motivo antes de concluir esta atividade.`)
};

/**
* | output |
* | --- |
* | "Select a reason before completing this activity." |
*
* @param {Task_Decline_Reason_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_decline_reason_required = /** @type {((inputs?: Task_Decline_Reason_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Decline_Reason_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_decline_reason_required(inputs)
	return pt_br2_task_decline_reason_required(inputs)
});